import { computed, inject } from '@angular/core';
import {
  signalStore,
  withState,
  withMethods,
  withComputed,
  patchState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { CodeValue } from '@app/models/code-value';
import { switchMap, tap } from 'rxjs/operators';
import { CostCenterService } from './cost-center.service';

type CostCenterState = {
  costCenters: CodeValue[];
  isLoading: boolean;
  error: string | null;
};

const initialState: CostCenterState = {
  costCenters: [],
  isLoading: false,
  error: null,
};

export const CostCenterStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed((store) => ({
    hasError: computed(() => store.error() !== null),
  })),
  withMethods((store, service = inject(CostCenterService)) => ({
    loadCostCenters: rxMethod<string>(
      pipe(
        tap(() => patchState(store, { isLoading: true, error: null })),
        switchMap((filter) =>
          service.getCostCenters(filter).pipe(
            tapResponse({
              next: (costCenters) =>
                patchState(store, { costCenters, isLoading: false }),
              error: () =>
                patchState(store, {
                  isLoading: false,
                  error: 'Failed to load Cost Centers!',
                }),
            }),
          ),
        ),
      ),
    ),
  })),
);
